import { BASE_URL } from '../components/App';

const INVALID_FRANCHISE_VALUES = new Set([
  'none',
  'null',
  'undefined',
  'all',
  'All',
]);

export const isValidFranchiseId = (value) =>
  value !== null &&
  value !== undefined &&
  value !== '' &&
  !INVALID_FRANCHISE_VALUES.has(String(value));

export const resolveFranchiseId = (...candidates) =>
  candidates.find((value) => isValidFranchiseId(value));

export async function fetchViewedUserFranchiseId(userId, token) {
  if (!userId || !token) {
    return null;
  }

  try {
    const response = await fetch(`${BASE_URL}/auth/user/info/${userId}`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });
    const result = await response.json();
    return result?.user?.franchisee_id ?? null;
  } catch {
    return null;
  }
}

export async function fetchFormFieldDefinitions({
  formName,
  token,
  userId = null,
  extraFranchiseCandidates = [],
}) {
  const viewedUserFranchiseId = userId
    ? await fetchViewedUserFranchiseId(userId, token)
    : null;

  const resolvedFranchiseId = resolveFranchiseId(
    viewedUserFranchiseId,
    ...extraFranchiseCandidates,
    localStorage.getItem('selectedFranchise'),
    localStorage.getItem('franchisee_id')
  );

  const params = new URLSearchParams({
    form_name: formName,
    request: 'user',
  });

  if (resolvedFranchiseId) {
    params.set('franchisee_id', String(resolvedFranchiseId));
  }

  const response = await fetch(`${BASE_URL}/field?${params.toString()}`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });

  const result = await response.json();
  return result?.result || {};
}
